import { render, staticRenderFns } from "./memberWorks.vue?vue&type=template&id=49dde79c&"
import script from "./memberWorks.vue?vue&type=script&lang=js&"
export * from "./memberWorks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports